import React from "react";
import AccountTypeGrid from "./AccountTypeGrid";

const AccountTypePage = () => {
  return (
    <div className="c-main">
      <div className="c-content">
        <AccountTypeGrid />
      </div>
    </div>
  );
};
export default AccountTypePage;
